export default __webpack_public_path__ + "static/media/complementary--priority-route-at-intersection--g4.fc911c8e.png";